/** True only on the Vite dev server — never on Vercel or production. */
export function isLocalDev() {
  return Boolean(import.meta.env.DEV);
}
